import Skeleton from '@/components/common/Skeleton';
import styled from 'styled-components';

const ImageSkeleton = () => <Skeleton height={'320px'} />;
const RegionSkeleton = () => <Skeleton width={'70px'} height={'20px'} />;
const NameSkeleton = () => <Skeleton width={'180px'} height={'20px'} />;
const PriceSkeleton = () => <Skeleton width={'150px'} height={'20px'} />;
const StarSkeleton = () => <Skeleton width={'35px'} height={'20px'} />;
const ButtonSkeleton = () => <Skeleton height={'40px'} />;
const SpecialTimeSkeleton = () => <Skeleton height={'40px'} />;

type Props = {
  isSpecialSection?: boolean;
};

const DefaultProductSkeleton = ({ isSpecialSection = false }: Props) => {
  return (
    <SkeletonContainer>
      {isSpecialSection && <SpecialTimeSkeleton />}
      <ImageSkeleton />
      <RegionSkeleton />
      <NameSkeleton />
      <PriceSkeleton />
      <StarSkeleton />
      <ButtonSkeleton />
    </SkeletonContainer>
  );
};

export default DefaultProductSkeleton;

const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
